import { render, staticRenderFns } from "./BranchList.vue?vue&type=template&id=83c4fcb8&scoped=true&"
import script from "./BranchList.vue?vue&type=script&lang=ts&"
export * from "./BranchList.vue?vue&type=script&lang=ts&"
import style0 from "./BranchList.vue?vue&type=style&index=0&id=83c4fcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c4fcb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow})
